'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.intercomSetUnreadMessages = exports.intercomShowMessages = undefined;

var _analyticsConstants = require('./analyticsConstants');

var intercomShowMessages = exports.intercomShowMessages = function intercomShowMessages() {
    return { type: _analyticsConstants.INTERCOM_SHOW_MESSAGES };
};

var intercomSetUnreadMessages = exports.intercomSetUnreadMessages = function intercomSetUnreadMessages(count) {
    return { type: _analyticsConstants.INTERCOM_SET_UNREAD_MESSAGES, count: count };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/analytics/analyticsActions.js
// module id = 669
// module chunks = 0